// extracted by mini-css-extract-plugin
module.exports = {"play":"playBtn-module--play--l0g7L","hidden":"playBtn-module--hidden--2tCzb"};